import { $, merge } from "glamor";
import memoizeOne from "memoize-one";

export const queryBuilderStyles = memoizeOne(() =>
    merge(
        {
            width: "480px",
            margin: "20px",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#ffffff",
        },
        $(" .noFilters", {
            padding: "12.5px 20px",
            borderRadius: "5px",
            fontSize: "13px",
            backgroundColor: "#f6f6f6",
            margin: "0",
        }),
        $(" .queryBuilder", {
            maxHeight: "220px",
            overflow: "scroll",
        }),
        $(" .ruleGroup", {
            background: "transparent",
            border: "none",
            padding: "0",
        }),
        $(" .ruleGroup-addRule", {
            position: "absolute",
            bottom: "0",
            left: "20px",
        }),
        $(" .actions", {
            display: "flex",
            gap: "8px",
            marginTop: "20px",
            alignSelf: "flex-end",
        }),
        $(" .dependant-fields", {
            maxWidth: "297px",
            width: "100%",
        }),
        $(" .rule-fields", {
            width: "140px",
            maxWidth: "140px",
        }),
        $(" .ms-Dropdown-container", {
            flex: "auto",
            minWidth: "115px",
        }),
        $(" .ms-Dropdown-title", {
            margin: "0",
        }),
        // Hide components
        $(" .ruleGroup-combinators", {
            display: "none",
        }),
        $(" .rule-operators", {
            display: "none",
        }),
        $(" .rule-operators + .ms-TooltipHost", {
            width: "100%",
        }),
        $(" .rule.dependant-fields > .ms-TooltipHost", {
            width: "100%",
        }),
    ),
);
